<!--隐患依据-->
<template>
    <div class="hbn-container" id="userInfo" v-loading="loading" element-loading-text="文件导出中..."
        element-loading-background="rgba(122, 122, 122, 0.8)">
        <div class="search-form">
            <el-row :gutter="24">
                <el-col :span="20">
                    <el-form ref="form" :model="form" label-width="80px" label-position="right" size="mini">
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="隐患描述">
                                    <el-input id="Name" v-model="PageQuery.queryModel.troubleDescribe" placeholder="隐患描述"
                                        clearable />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="判定依据">
                                    <el-input id="Name" v-model="PageQuery.queryModel.judgment" placeholder="判定依据"
                                        clearable />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="适合行业">
                                    <el-input id="Name" v-model="PageQuery.queryModel.industry" placeholder="适合行业"
                                        clearable />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-show="show" :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="依据强度">
                                    <el-input id="Name" v-model="PageQuery.queryModel.intension" placeholder="依据强度"
                                        clearable />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="隐患等级">
                                    <el-input id="Name" v-model="PageQuery.queryModel.level" placeholder="隐患等级" clearable />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="创建时间">
                                    <el-date-picker v-model="PageQuery.queryModel.creationTime" type="datetimerange"
                                        range-separator=" - " start-placeholder="开始" end-placeholder="结束"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
                <el-col :span="4">
                    <el-form-item>
                        <el-button size="mini" class="hbn-button-serach" @click="seach">查找</el-button>
                        <span class="control-collapse" @click="show = !show">{{
                            show ? "收起" : "展开"
                        }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>

        <div class="hbn-table-screen">
            <div class="operation">
                <el-button class="custom-button" type="primary" @click="addData">
                    <i class="el-icon-circle-plus-outline custom-icon"></i>
                    <span>新增</span>
                </el-button>
                <el-button
                    class="custom-button"
                    type="primary"
                    style="width: 6rem"
                    @click="BatchDel"
                    >
                    <i class="el-icon-delete custom-icon"></i>
                    <span>批量删除</span>
                </el-button>
                <el-button type="primary" class="custom-button" @click="importExcel">
                    <i class="el-icon-upload custom-icon"></i>
                    <span>导入</span>
                </el-button>
                <el-button type="primary" class="custom-button" @click="exportExcel">
                    <i class="el-icon-download custom-icon"></i>
                    <span>导出</span>
                </el-button>
            </div>

            <div class="custom-table-layer">
                <div style="margin-bottom: 13px">
                    <vxe-table :data="DataList" round border height="388" class="mytable-scrollbar" style="width: 100%"
                        :highlight-current-row="true" @current-change="handleCurrentChange" 
                        @checkbox-change="handleSelectionChange"
                        @checkbox-all="selectAllChangeEvent"
                        ref="multipleTable"
                        highlight-hover-row highlight-hover-column highlight-current-column show-overflow="tooltip"
                        empty-text="没有更多数据了！" resizable stripe>
                        <vxe-table-column fixed="left" type="checkbox" width="40" ></vxe-table-column>
                        <vxe-table-column fixed="left" type="seq" width="55" title="序号" align="center"></vxe-table-column>
                        <template v-for="item in UnitList">
                            <vxe-table-column :key="item.prop" :field="item.prop" :title="item.label" :width="item.width"
                                align="center" v-if="item.isShow" show-overflow-tooltip />
                        </template>
                        <vxe-table-column width="120" fixed="right" title="操作" align="center">
                            <template #default="{ row, rowIndex }">
                                <el-button size="small" type="text"
                                    @click="onColumnClick(row, rowIndex, 'view')">查看</el-button>
                                <el-button size="small" type="text"
                                    @click="onColumnClick(row, rowIndex, 'edit')">编辑</el-button>
                                <el-popconfirm title="是否要删除?" @confirm="onColumnClick(row, rowIndex, 'delete')">
                                    <template #reference>
                                        <el-button size="small" type="text">删除</el-button>
                                    </template>
                                </el-popconfirm>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>

                <div class="pagination">
                    <vxe-pager perfect size="mini" :current-page="PageQuery.pageindex" :page-size="PageQuery.PageSize"
                        :page-sizes="[20, 50, 100, 500]" :total="total" :pager-count="5" :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'FullJump',
                            'Sizes',
                            'Total',
                        ]" @page-change="handlePageChange">
                    </vxe-pager>
                </div>
            </div>
        </div>

        <hazardBasisEdit ref="hazardBasisEdit" v-model:dialogVisible="dialogVisible" @close-dialog="closeDialog"
            @handle-cancel="handleCancel" @handle-confirm="handleConfirm"></hazardBasisEdit>
        <excel controlName="hiddenTrouble" fileName="隐患依据导入模板.xlsx" :dialogVisible="UpLoaddialogVisible"
            @close-dialog="closeUpDialog" @error="error" @success="success" type="铁安通"></excel>
    </div>
</template>
  
<script>
import { Search } from "@element-plus/icons";
import { GetDataHiddenTroubleList, DeleteDataHiddenTrouble, ExportDataHiddenTrouble, DeleteTroubles } from "@api/ApiHazardBasis";
import { hazardBasisList } from "@/assets/apiData/hazardBasis";
import hazardBasisEdit from "@comp/Resource/hazardBasisEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import { ElMessage } from "element-plus";
import { dateFormat } from "@/util/utils.js";
import Enumerable from "linq";
export default {
    name: "hazardBasis",
    data() {
        return {
            PageQuery: {
                queryModel: {
                    troubleDescribe: "",
                    judgment: "",
                    industry: "",
                    intension: "",
                    level: "",
                    creationTime: ""
                },
                pageindex: 1,
                PageSize: 20,
            },
            total: 0,
            show: false,
            UnitList: hazardBasisList,
            DataList: [],
            loading: false,
            multipleSelection: [],
            dialogVisible: false,
            UpLoaddialogVisible: false,
        };
    },
    components: {
        excel,
        Search,
        hazardBasisEdit
    },
    created() {
        this.GetData();
    },
    methods: {
        addData() {
            this.$refs.hazardBasisEdit.initDialog('insert')
        },
        importExcel() {
            this.UpLoaddialogVisible = true;
        },
        closeUpDialog() {
            this.UpLoaddialogVisible = false;
            this.PageQuery.pageindex = 1;
            this.GetData();
        },
        exportExcel() {
            this.loading = true;
            try {
                ExportDataHiddenTrouble(this.PageQuery).then((result) => {
                    this.loading = false;
                });
            } catch (e) {
                this.loading = false;
                console.log(e);
            }
        },
        seach() {
            this.PageQuery.pageindex = 1;
            this.GetData();
        },
        handlePageChange({ currentPage, pageSize }) {
            if (this.PageQuery.PageSize != pageSize) {
                this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
                this.PageQuery.PageSize = pageSize;
            } else {
                this.PageQuery.pageindex = currentPage;
            }
            this.GetData();
        },
        handleCurrentChange(val) {
            console.log(val);
            this.GetData();
        },
        //选中事件
        handleSelectionChange({ records }) {
            this.multipleSelection = records;
        },
        //全选
        selectAllChangeEvent({ checked, records }) {
            this.multipleSelection = records;
        },
        GetData() {
            const _this = this;
            try {
                let creationBeginTime = "";
                let creationEndTime = "";
                if (_this.PageQuery.queryModel.creationTime) {
                    creationBeginTime = dateFormat(
                        "YYYY-mm-dd",
                        _this.PageQuery.queryModel.creationTime[0]
                    );
                    creationEndTime = dateFormat(
                        "YYYY-mm-dd",
                        _this.PageQuery.queryModel.creationTime[1]
                    );
                }
                let PageQuery = JSON.parse(JSON.stringify(_this.PageQuery));
                PageQuery.queryModel = {
                    ...PageQuery.queryModel,
                    creationBeginTime,
                    creationEndTime,
                };
                delete PageQuery.queryModel.creationTime;
                GetDataHiddenTroubleList(PageQuery).then(function (data) {
                    _this.DataList = data.entities.map(item => {
                        return {
                            ...item,
                            creationTime: item.creationTime && _this.$moment(item.creationTime).format('YYYY-MM-DD HH:mm:ss')
                        }
                    });
                    _this.total = data.totalCount;
                });
            } catch (e) {
                console.log(e);
            }
        },
        closeDialog() {
            this.dialogVisible = false;
            this.PageQuery.pageindex = 1;
            this.GetData();
        },
        handleCancel() {
            this.dialogVisible = false;
            this.PageQuery.pageindex = 1;
            this.GetData();
        },
        handleConfirm(val) {
            this.dialogVisible = false;
            this.PageQuery.pageindex = 1;
            this.GetData();
        },
        // type edit:编辑  delete:删除
        onColumnClick(data, index, type) {
            switch (type) {
                case 'view':
                case 'edit':
                    this.Detail(type, data);
                    break;
                case 'delete':
                    this.Delete(data);
                    break;
                default:
                    break;
            }
        },
        // 删除
        Delete(data) {
            DeleteDataHiddenTrouble(data.id)
                .then((res) => {
                    ElMessage.success("删除成功");
                    this.GetData();
                })
                .catch((err) => {
                    ElMessage.error(err);
                });
        },
        // 获取详情
        Detail(type, data) {
            this.$refs.hazardBasisEdit.initDialog(type, data)
        },
        //批量删除
        BatchDel() {
            if (this.multipleSelection.length == 0) {
                this.$message.warning("请选择要删除的隐患依据");
                return;
            }
            this.$confirm(`确定删除？`, "提示", {
                cancelButtonClass: "cancelstyle",
                confirmButtonClass: "confirmstyle",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false,
            })
            .then(() => {
                let troubleIds = Enumerable.from(this.multipleSelection)
                .select((ss) => ss.id)
                .toArray();
                DeleteTroubles(troubleIds)
                .then((res) => {
                    this.$message.success("批量删除成功");
                    this.GetData();
                })
                .catch((message) => {
                    this.$message.error(message);
                });
            })
            .catch(() => {
                return;
            });
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";

.custom-table-header>th {
    background: #dfdfdf !important;
}

.custom-table-header>th>.cell {
    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
    font-weight: 500;
    color: #868686 !important;
    line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
    color: #32383d;
}

.el-table .cell {
    color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    display: none;
}

.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
    border: 1px solid #acb5bd;
    width: 32px;
    height: 32px;
    line-height: 32px;
    background-color: #fff;
}

::v-deep .el-input-number__decrease {
    display: none;
}

::v-deep .el-input-number__increase {
    display: none;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
</style>
<style scoped></style>
  